import template from "./decimal-degrees.html";
import "./decimal-degrees.less";

import { roundToRoundingPoint } from "services/math-service.js";
import {
	createCoordinateAxisSource,
	getComparableCoordinatePart,
	hasCoordinatePart,
	resolveCoordinateAxisValue
} from "../coordinate-axis-state.ts";
import { isValueNullish } from "../../../../../utils/valueUtilities";

export class Controller {
	currentValue = {
		latitude: {},
		longitude: {}
	};

	constructor($scope) {
		this._scope = $scope;
	}

	$onInit() {
		this.setValue(this.value);
		this._initialized = true;

		this._scope.$watch(
			() => this.currentValue,
			() => this.publishCurrentValue(),
			true
		);
	}

	$onChanges(changes) {
		if(this._initialized && !isValueNullish(changes.value) && changes.value.currentValue !== changes.value.previousValue) {
			this.setValue(changes.value.currentValue);
		}
	}

	setValue(value) {
		this.currentValue = {
			latitude: {
				number: hasCoordinatePart(value?.Latitude)
					? roundToRoundingPoint(value.Latitude, this.field)
					: undefined
			},
			longitude: {
				number: hasCoordinatePart(value?.Longitude)
					? roundToRoundingPoint(value.Longitude, this.field)
					: undefined
			}
		};
		this.sourceAxes = {
			latitude: createCoordinateAxisSource(
				value?.Latitude,
				this.currentValue.latitude,
				this.getAxisState
			),
			longitude: createCoordinateAxisSource(
				value?.Longitude,
				this.currentValue.longitude,
				this.getAxisState
			)
		};
		this.lastObservedState = this.getEditableState();
	}

	getAxisState = axis => getComparableCoordinatePart(axis.number);

	getEditableState() {
		return JSON.stringify({
			latitude: this.getAxisState(this.currentValue.latitude),
			longitude: this.getAxisState(this.currentValue.longitude)
		});
	}

	handleFieldChanged = () => {
		this.publishCurrentValue();
	}

	publishCurrentValue() {
		const editableState = this.getEditableState();
		if(editableState === this.lastObservedState) {
			return;
		}

		this.lastObservedState = editableState;
		const latitude = this.currentValue.latitude.number;
		const longitude = this.currentValue.longitude.number;
		const coordinateHasInput = hasCoordinatePart(latitude) || hasCoordinatePart(longitude);
		const value = coordinateHasInput ? {
			FieldId: this.field.Id,
			Latitude: this.getAxisValue(this.currentValue.latitude, this.sourceAxes.latitude),
			Longitude: this.getAxisValue(this.currentValue.longitude, this.sourceAxes.longitude)
		} : undefined;

		this.onValueChange({
			value,
			hasInput: coordinateHasInput,
			triggerEvent: false
		});
	}

	getAxisValue(axis, source) {
		return resolveCoordinateAxisValue(axis, source, this.getAxisState, editableAxis =>
			hasCoordinatePart(editableAxis.number) ? Number(editableAxis.number) : undefined
		);
	}
}

export default angular
	.module("vesl.components.report-form.coordinate.decimal-degrees", [])
	.component("decimalDegrees", {
		template,
		controller: Controller,
		bindings: {
			field: "<",
			value: "<",
			onValueChange: "&"
		}
	}).name;
